module.exports = __webpack_public_path__ + "static/hero-compensation-09890959ac428642f0fb9cfe1e631985.svg";